"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineIcon = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LineIconModule = _interopRequireDefault(require("../../styles/components/GroupCharts/LineIcon.module.css"));
var _gustyLine = _interopRequireDefault(require("../../icons/gustyLine"));
var _line = _interopRequireDefault(require("../../icons/line"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LineIcon = exports.LineIcon = /*#__PURE__*/(0, _react.memo)(_ref => {
  var _tActiveV$Colours;
  let {
    equipmentType,
    displayNameId,
    icon = {}
  } = _ref;
  const tActiveV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const getColor = (_tActiveV$Colours = tActiveV.Colours) !== null && _tActiveV$Colours !== void 0 && (_tActiveV$Colours = _tActiveV$Colours[equipmentType]) !== null && _tActiveV$Colours !== void 0 && _tActiveV$Colours[displayNameId] ? "#".concat(tActiveV.Colours[equipmentType][displayNameId]) : _constants.defaultLineColor;
  if ((icon === null || icon === void 0 ? void 0 : icon.type) === 'gusty_line') {
    return /*#__PURE__*/_react.default.createElement(_gustyLine.default, {
      stroke: getColor,
      className: _LineIconModule.default["icon-".concat(icon.type)]
    });
  }
  return /*#__PURE__*/_react.default.createElement(_line.default, {
    stroke: getColor,
    className: _LineIconModule.default["icon-".concat(icon.type)]
  });
});
LineIcon.propTypes = {
  equipmentType: _propTypes.default.string,
  displayNameId: _propTypes.default.string,
  icon: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['gusty_line', 'line']),
    strokeDasharray: _propTypes.default.string
  })
};